import HomepageController from '../../../base/js/pages/homepage/HomepageController';
import ScpHomepageCarousels, {TOP_OFFERS_CAROUSEL_SELECTOR} from '../components/ScpHomepageCarousels';

new HomepageController({
	'shouldInitializeCarousel': (carousel) => !carousel.matches(TOP_OFFERS_CAROUSEL_SELECTOR)
});

requestAnimationFrame(() => new ScpHomepageCarousels());